import styled, { css, keyframes } from 'styled-components';

import { muiPalette } from '@/shared/general-theme';

const rotate = keyframes`
  100% {
    transform: rotate(1turn);
  }
`;

const sizes = {
  xs: '1rem',
  sm: '2rem',
  md: '3rem', // default
  lg: '4.5rem',
};

interface LoaderStyledProps {
  size?: 'xs' | 'sm' | 'md' | 'lg';
}

export const LoaderStyled = styled.div<LoaderStyledProps>`
    ${({ size = 'md' }) => css`
        width: ${sizes[size]};
        aspect-ratio: 1.154;
        display: grid;
        color: ${() => muiPalette.primary.main};
        background: linear-gradient(to bottom left, transparent calc(50% - 1px), currentColor 0 calc(50% + 1px), transparent 0) right/50% 100% no-repeat,
        linear-gradient(to bottom right, transparent calc(50% - 1px), currentColor 0 calc(50% + 1px), transparent 0) left/50% 100% no-repeat,
        linear-gradient(currentColor 0%, currentColor 100%) bottom/100% 2px no-repeat;

        transform-origin: 50% 66%;
        animation: ${rotate} 4s infinite linear;

        &::before,
        &::after {
            content: "";
            grid-area: 1/1;
            background: inherit;
            transform-origin: inherit;
            animation: inherit;
        }

        &::after {
            animation-duration: 2s;
        }
    `}
`;